import { MouseEventHandler, useState } from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { ListItemButton } from '@mui/material';

import clsx from 'clsx';

import { NavText } from '../NavText';
import { DesktopNavInner } from './DesktopNavInner';
import { MobileNavInner } from './MobileNavInner';

import { useIsMobile } from '../../../hooks';
import { NavItemMultiple } from '../../navigation.types';
import { AnchorType } from './types';

export const MultiLevelNavItem = ({ subItems, text, isActive, buttonProps, isNewTheme, onClick }: NavItemMultiple) => {
  const [anchorEl, setAnchorEl] = useState<AnchorType>(null);
  const isMobile = useIsMobile();
  const open = Boolean(anchorEl);

  const handleClick: MouseEventHandler<HTMLDivElement> = (event) => {
    isMobile ? setAnchorEl(anchorEl ? null : event.currentTarget) : setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSubItemClick = () => {
    onClick?.();
    handleClose();
  };

  return (
    <>
      <ListItemButton
        className={clsx('nav-item', { 'selected-nav': isActive, open })}
        onClick={handleClick}
        selected={isActive}
        {...buttonProps}
      >
        <NavText>{text}</NavText>
        {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
      </ListItemButton>
      {isMobile ? (
        <MobileNavInner open={open} subItems={subItems} onSubItemClick={handleSubItemClick} />
      ) : (
        <DesktopNavInner
          open={open}
          subItems={subItems}
          onSubItemClick={handleSubItemClick}
          anchorEl={anchorEl}
          handleClose={handleClose}
        />
      )}
    </>
  );
};
